import urlJoin from 'url-join';
import AcfTippy from './AcfTippy';
import AcfTableField from './AcfTableField';
import DpitMultiStateAnimBtn from './DpitMultiStateAnimBtn';
import DpitAdminBtnActions from './DpitAdminBtnActions';

import DpitHooks from '../../../../includes/assets/js/modules/DpitHooks';
import {
	getRedirectUrlQueryString,
	scrollToOriginElementByUrlAndAnimate,
	createOrSetManuallyElement
} from './dp-admin-utils';

import {
	wrapElementByContainer,
	scrollToElementAndAnimate,
	sanitizePossibleRelativeUrl
} from '../../../../includes/assets/js/modules/dpitUtilsInc';

import DpitAdminToolbar, { BTN_ID } from './DpitAdminToolbar';
import { Origin, TargetType } from '../../../../public/assets/js/apps/TourStepEditor/store/appMode';



export const IDS = {
	stepTable: 'dpit-step-table',
	stepBuilderBtn: 'dpit-step-builder-btn',
	triggerGroupPrefix: 'dpit-trigger-group-',
	triggerBtnPrefix: 'dpit-trigger-btn-',
	postBodyContent: 'wpbody-content',
	slugBox: 'edit-slug-box',
	loader: 'dpit-admin-tour-edit-loader',
};

export const CLASSES = {
	adminBtn: 'dpit-admin-btn',
	adminBtnWrap: 'dpit-admin-btn-wrap',
	orSetManually: 'dpit-or-set-manually',
	tourIdLabel: 'dpit-tour-id',
	loaderTitle: 'dpit-loader__title',
	loader: 'dpit-loader',
	animPulse: 'dpit-admin-pulse-anim'
};

export const TRIGGER_IDX = {
	regular: 0,
	additional: 1
};

export const SELECTORS = {
	stepsTable: '.acf-field-table[data-name="intro_steps"] .acf-table-table',
	acfPageLinkRemoveChoice: '.select2-selection__choice__remove',
	acfTriggerMode: '.acf-field[data-name="trigger_mode"]',
};


export default class DpitAdminTourEdit {

	/* SECTION INIT */

	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT ' + this.printModuleName());
		this.config = config;
		this.preInit();
		this.initAcfActions();
		this.initTourVisitClearButton();
	}

	initAcfActions() {
		window.acf.addAction('load', () => {
			this.initSubModules(() => {
				if (this.init()) {
					this.runAfterInitActions();
				}
			});
		});

		window.acf.addAction('invalid_field', () => {
			this.deactivateLoader();
			if (this.adminToolBar) this.adminToolBar.stopPrimaryBtnAnimation();
		});
	}

	preInit() {
		this.firstStepUrl = this.config.tourStartPageUrl;
	}

	init() {
		this.postRootEl = document.getElementById(IDS.postBodyContent);
		this.publishBtnOrigEl = document.getElementById('publish');
		if (this.postRootEl) {
			this.initTriggers();
			this.initStepBuilder();
			this.initAcfPageLinkLongTouch();
			this.initLoader();
			return true;
		}
		return false;
	}


	initTourVisitClearButton() {
		new DpitAdminBtnActions(
			this.config,
			{
				clear_visits_4_tour: {
					tourId: this.config.tourId,
				}
			}
		);
	}

	async runAfterInitActions() {
		this.renderStartUrlAndTourId();
		this.renderBuilderStepsButton();
		this.renderTriggerButton(TRIGGER_IDX.regular);
		this.startButtonsClickAbilityAutoUpdate();
		this.startTriggerSelectorLabelAutoUpdate();
		this.startIsChangeCheck();
		this.adminToolBar.render(false);
		this.actualizeToolbar(this.isReady);

		this.deactivateLoader();

		const isScrolling = await scrollToOriginElementByUrlAndAnimate(
			this.config.queryParamsDefs,
			CLASSES.animPulse,
			{ align: { top: 0, topOffset: 40, lockX: true } }
		);
		if (!isScrolling) {
			if (!this.adminToolBar.scrollToStoredScrollTop()) {
				$(document.documentElement).scrollTop(0);
			}
		}
		DpitHooks.doAction('adminEditTourLoaded', { tourId: this.config.tourId });

	}



	activateLoader(label = null, hidePostContent = true, delay = 500) {
		if (this.loaderEl) {
			if (label) {
				const loaderTitleEl = this.loaderEl.querySelector('.' + CLASSES.loaderTitle);
				if (loaderTitleEl) loaderTitleEl.innerHTML = label;
			}
			if (delay > 0) {
				setTimeout(() => {
					this.loaderEl.classList.remove(CLASSES.loader + '--inactive');
					if (hidePostContent) {
						this.hidePostContent();
					}
				}, delay);
			}
			else {
				this.loaderEl.classList.remove(CLASSES.loader + '--inactive');
				if (hidePostContent) {
					this.hidePostContent();
				}
			}
		}
	}


	deactivateLoader(showPostContent = true) {
		if (this.loaderEl) {
			this.loaderEl.classList.add(CLASSES.loader + '--inactive');
			if (showPostContent) this.showPostContent();
		}
	}

	initLoader() {
		this.loaderEl = document.getElementById(IDS.loader);
	}

	showPostContent() {
		if (this.postRootEl) this.postRootEl.style.opacity = 1;
	}

	hidePostContent() {
		if (this.postRootEl) this.postRootEl.style.opacity = 0;
	}

	initSubModules(afterInitCb) {
		this.stepsTable = new AcfTableField({
			...this.config.acfTable,
			i18n: this.config.i18n,
			stepDefinitions: this.config.stepDefinitions
		}, this.actualize.bind(this), this.onNewTableRowAdded.bind(this));
		this.acfTippy = new AcfTippy(this.config, () => {
			this.stepsTable.ui_init_drag_to_scroll();
			afterInitCb();
		});
		this.adminToolBar = new DpitAdminToolbar(this.config, false, false, this.onRedirectingFromToolbar.bind(this), false);
	}

	onRedirectingFromToolbar(buttonId, actionTitle = '') {
		this.beforeRedirecting();
		this.activateLoader(actionTitle + ' ...');
	}

	onNewTableRowAdded() {
		if (this.acfTippy) this.acfTippy.reloadInfoIcons();
		this.actualize();
	}

	initTrigger(triggerIdx = TRIGGER_IDX.regular) {
		const groupEl = this.postRootEl.querySelector(`.acf-field[data-name="${this.getTriggerAcfGroupName(triggerIdx)}"]`);
		if (groupEl) {
			groupEl.id = IDS.triggerGroupPrefix + triggerIdx;
			this.triggersData.push({
				groupEl
			});
		}
	}

	initStepBuilder() {
		this.startUrlOptionEl = this.getStartUrlOptionEl();
		this.stepsTableEl = this.postRootEl.querySelector(SELECTORS.stepsTable);
	}

	initTriggers() {
		this.triggersData = [];
		this.initTrigger(TRIGGER_IDX.regular);
	}

	initAcfPageLinkLongTouch() {
		// to do
		$(SELECTORS.acfPageLinkRemoveChoice).on('touchstart click', (event) => {
			const jLi = $(event.target).closest('li');
			if (jLi.length) {
				$(jLi[0]).remove();
			}
		});
	}

	/* !SECTION INIT */


	/* SECTION RENDER*/

	renderStartUrlAndTourId() {
		this.slugBoxEl = this.postRootEl.querySelector('#' + IDS.slugBox);
		if (this.slugBoxEl) {
			const permalinkStrongTagEl = this.slugBoxEl.querySelector('strong');
			if (permalinkStrongTagEl) {
				permalinkStrongTagEl.innerText = this.config.i18n.permalink_title;
			}

			const tourIdEl = document.createElement('span');
			tourIdEl.className = 'dpit-tour-id';
			tourIdEl.innerText = this.config.i18n.tour_id + ' : ' + this.config.tourId;
			this.slugBoxEl.appendChild(tourIdEl);
		}
	}


	actualizeAllTourStartUrlLinks(isReady, startUrlHref = '', startUrlLabel = '') {
		const $adminBarViewEl = $('.updated.notice');
		if (isReady) {
			const $AdminBarViewTourBtnLinkEl = $('#wp-admin-bar-view a, .updated.notice > p > a');
			const $PermalinkEl = $(this.slugBoxEl).find('#sample-permalink');

			if (startUrlHref) {
				const startUrlHrefAbs = sanitizePossibleRelativeUrl(startUrlHref, this.config.siteUrl);

				$PermalinkEl.attr('href', startUrlHrefAbs);
				$AdminBarViewTourBtnLinkEl.attr('href', startUrlHrefAbs);
			}
			if (startUrlLabel) {
				$PermalinkEl.text(startUrlLabel);
			}

			$adminBarViewEl.show();
			$(this.slugBoxEl).show();
		} else {
			$adminBarViewEl.hide();
			$(this.slugBoxEl).hide();

		}
	}


	renderBuilderStepsButton() {
		const toInsertAfterEl = document.querySelector('.acf-field-table[data-name="intro_steps"] .acf-label');
		if (toInsertAfterEl) {
			this.builderStepsBtn = new DpitMultiStateAnimBtn(
				args => this.obBtnClick(args, TargetType.STEP, IDS.stepTable),
				this.getBtnState(this.config.i18n.configure_steps_visually),
				'default',
				CLASSES.adminBtn,
				['button-primary', CLASSES.adminBtn + '--xl'],
				false,
				IDS.stepBuilderBtn,
			);

			const filledContainerEl = wrapElementByContainer(
				this.builderStepsBtn.getButtonElement(),
				CLASSES.adminBtnWrap,
				'',
				createOrSetManuallyElement(this.config.i18n.or_set_man_table, CLASSES.orSetManually)
			);
			toInsertAfterEl.after(filledContainerEl);
		}
	}

	renderTriggerButton(triggerIdx) {
		const triggerData = this.triggersData[triggerIdx];
		if (triggerData) {
			const triggerGroupEl = triggerData.groupEl;
			if (triggerGroupEl) {
				const toInsertBeforeEl = triggerGroupEl.querySelector('.acf-field[data-name="intro_trigger_selector"] .acf-input');
				if (toInsertBeforeEl) {

					triggerData.button = new DpitMultiStateAnimBtn(
						args => this.obBtnClick(args, TargetType.TRIGGER, 'dpit-trigger-selector-' + triggerIdx, triggerIdx),
						this.getBtnState(this.config.i18n.set_visually),
						'default',
						CLASSES.adminBtn,
						['button-primary', CLASSES.adminBtn + '--xl'],
						false,
						IDS.triggerBtnPrefix + triggerIdx,
					);

					triggerData.btnWrapEl = wrapElementByContainer(
						triggerData.button.getButtonElement(),
						CLASSES.adminBtnWrap,
						'',

						createOrSetManuallyElement(this.config.i18n.or_set_man, CLASSES.orSetManually)
					);
					toInsertBeforeEl.before(triggerData.btnWrapEl);
				}
			}
		}
	}

	/* !SECTION RENDER*/


	/* SECTION EVENTS */

	obBtnClick(args, targetType, originId, originSubIdx = null) {
		switch (args.state) {
			case 'undef-start': this.scrollToStartUrl(); break;
			case 'default':
				{
					const button = args.button;
					button.startAnimation();
					this.adminToolBar.deactivate();
					this.beforeRedirecting();

					const redirectQueryString = getRedirectUrlQueryString(this.config.queryParamsDefs, this.config.tourId, targetType, originId, Origin.ADMIN, originSubIdx);
					if (this.isUnsavedChange) {
						this.activateLoader(this.config.i18n.storingChanges, true, 1000);
						this.setTransientAndPressPrimaryButton(redirectQueryString, this.config.i18n.loadingFB, () => {
							button.stopAnimation();
						});
					} else {
						this.activateLoader(this.config.i18n.loadingFB, true, 1000);
						try {
							this.redirectToFirstStepUrl(redirectQueryString);
						} catch (error) {
							console.error(error);
						}

					}
				}
				break;
		}
	}

	async redirectToFirstStepUrl(redirectQueryString) {
		const firstStepLink = await this.getFirstStepLink();
		if (firstStepLink?.url) {
			const redirectUrl = urlJoin(this.config.siteUrl, firstStepLink.url, redirectQueryString);
			window.location.href = redirectUrl;
		}
	}

	beforeRedirecting() {

	}

	beforeUnload() {
		if (!this.isUnsavedChange) {
			this.adminToolBar.storeCurrentScrollTop();
		}
	}

	/* !SECTION EVENTS */


	/* SECTION STATES */

	startIsChangeCheck() {
		window.addEventListener('beforeunload', this.beforeUnload.bind(this));
		$('.acf-field').on('change', () => {
			this.isUnsavedChange = true;
			this.adminToolBar?.setIsChange();
		});
	}

	actualizeButtonsState(state) {
		this.builderStepsBtn.setOnlyState(state);
		this.triggersData.forEach(triggerData => {
			triggerData?.button.setOnlyState(state);
		});
	}

	actualizeToolbar(isReady) {
		if (!isReady) {
			this.adminToolBar.hideButtons(BTN_ID.preview, BTN_ID.view);
		}
		else {
			this.adminToolBar.showButtons(BTN_ID.preview, BTN_ID.view);
		}
	}

	async actualize(useLastStartUrl = true) {
		this.actualizeCore(this.triggersData[TRIGGER_IDX.regular]?.groupEl?.querySelector(
			'.acf-field[data-name="intro_related_posts"] ul.select2-selection__rendered li:not(.select2-search--inline)'
		) !== null);
		try {
			if (useLastStartUrl && this.firstStepUrl) {
				this.actualizeCore(this.firstStepUrl !== null, this.firstStepUrl);
			} else {
				const firstStepLink = await this.getFirstStepLink();
				this.firstStepUrl = firstStepLink?.url;
				if (this.firstStepUrl) {
					this.actualizeCore(this.firstStepUrl !== null, this.firstStepUrl);
				}
			}

		} catch (error) {
			console.error(error);
		}
	}

	actualizeCore(isReady, firstStepUrl = null) {
		this.isReady = isReady;
		this.actualizeToolbar(isReady);
		this.actualizeAllTourStartUrlLinks(isReady);
		this.actualizeButtonsState(isReady ? 'default' : 'undef-start');
		if (isReady && firstStepUrl) {
			this.actualizeAllTourStartUrlLinks(
				true,
				firstStepUrl,
				this.getStepUrlLabel(firstStepUrl)
			);
		}
		else {
			this.actualizeAllTourStartUrlLinks(false);
		}
	}




	actualizeTriggerSelectorLabel(groupEl) {
		const triggerSelectorLabelEl = groupEl.querySelector('.acf-field[data-name="intro_trigger_selector"]>.acf-label>label');
		if (triggerSelectorLabelEl) {
			const value = groupEl.querySelector('input:checked')?.value;
			if (value === 'button') {
				triggerSelectorLabelEl.innerHTML = this.config.i18n.button;
			} else {
				triggerSelectorLabelEl.innerHTML = this.config.i18n.element;
			}
		}

	}

	startButtonsClickAbilityAutoUpdate() {
		this.actualize();
		new window.acf.Model({
			events: {
				'change .acf-field-page-link': 'onChange',
			},
			onChange: () => this.actualize(false)
		});
	}

	startTriggerSelectorLabelAutoUpdate() {
		this.triggersData.forEach(triggerCfg => {
			const modeEl = triggerCfg.groupEl.querySelector(SELECTORS.acfTriggerMode);
			if (modeEl) {
				modeEl.addEventListener(
					'change',
					() => this.actualizeTriggerSelectorLabel(triggerCfg.groupEl)
				);
			}
		});
	}

	/* !SECTION STATES */


	/* SECTION UTILS */

	printModuleName() {
		return 'DpitAdminTourEdit';
	}

	getStepUrlLabel(relativeUrl) {
		return relativeUrl === '/' ? this.config.i18n.HOME_PAGE : relativeUrl;
	}


	getBtnState(activeLabel) {
		return {
			'default': activeLabel,
			'undef-start': { content: this.config.i18n.set_first_step_url_FREE, activeMod: 'undef' }
		};
	}

	async getFirstStepLink() {
		const ids = this.getAcfFieldVal('intro_related_posts');
		if (ids) {
			const id = ids[0];
			const url = await this.postAjaxData(
				'get-permalink',
				{ id }
			);
			return {
				url: url,
				label: url
			};
		} else return null;
	}

	getAcfFieldVal(name, def = null) {
		const fields = window.acf.getFields({ name });
		if (fields) {
			return fields[0].val();
		}
		return def;
	}



	async setTransientAndPressPrimaryButton(redirectQueryString, loaderLabel, onComplete = null) {
		try {
			await this.ajaxSetTransient('dpit_builder_transient', redirectQueryString, this.config.tourId, 30);
			this.activateLoader(loaderLabel, true, 1000);
			this.pressPrimaryButton();
			if (onComplete instanceof Function) onComplete(true);
		} catch (err) {
			console.error(err, err?.stack);
			if (onComplete instanceof Function) onComplete(false);
		}
	}

	getStartUrlOptionEl() {
		return this.postRootEl.querySelector('.acf-field[data-name="intro_trigger"] .acf-field[data-name="intro_related_posts"]');
	}

	async scrollToStartUrl() {
		return await scrollToElementAndAnimate(this.startUrlOptionEl);
	}

	postAjaxData(route, dataToPost) {
		return $.ajax({
			url: urlJoin(this.config.restApiUrl, 'dpintrotours/v1/', route),
			type: 'post',
			data: dataToPost,
			headers: { 'X-WP-Nonce': this.config.nonces.wp_rest },
		});
	}

	async ajaxSetTransient(transientName, redirectQueryString, postId, expirationS) {
		return await this.postAjaxData(
			'set-transient',
			{
				name: transientName,
				expirationS: expirationS,
				transientData: {
					postId: postId,
					redirectQueryString: redirectQueryString,
					isGlobalStartAtAllPagesSet: this.isGlobalStartAtAllPagesSet() ? 1 : 0
				}
			}
		);
	}

	pressPrimaryButton() {
		$(this.publishBtnOrigEl).trigger('click');
	}

	getTriggerAcfGroupName(triggerIdx) {
		return triggerIdx === TRIGGER_IDX.regular ? 'intro_trigger' : 'intro_trigger_2';
	}

	isGlobalStartAtAllPagesSet() {
		return $('.acf-field[data-name="global_start_at_all_pages"] .acf-switch').hasClass('-on');
	}
	/* !SECTION UTILS */
}